@if (isLoading() || !products()?.length) {
    <div class="skeleton-container">
        <ng-container *ngTemplateOutlet="skeletonService.productCardsTemplate()"></ng-container>
    </div>
} @else {
    <lib-product-card-slider
        [actionText]="section().buttonText"
        [ariaLabelAction]="section().buttonText"
        [isLoading]="isLoading()"
        [products]="products()"
        [subTitle]="section().subtitle"
        [title]="section().title"
        [withControls]="!isMobile()"
        (action)="onAction()"
    />
}
